import React, { useEffect, useState } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Paper,
  useMediaQuery,
  Button,
  FormHelperText,
} from "@mui/material";
import styled, { inputStyles } from "../../Utils/inputChanges";
import Titlebar from "../TitleBar";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { errorStyles } from "../../Utils/table";
import { createDepartmentEntry } from "../../Store/PHPSlice/Department";
import { useDispatch, useSelector } from "react-redux";
import DepartmentTable from "../MasterTables/DepartmentTable/DepartmentTable";
import { insertTeamLeader } from "../../Store/PHPSlice/TeamLeader/TeamLeader";
import { selectFirm } from "../Selectors/Master/ItemSelectors";
import { fetchCompanyData } from "../../Store/PHPSlice/Firm";
import DropdownWithBtn from "../FieldsComponents/DropdownWithBtn";
import TeamLeaderTable from "../MasterTables/TeamLeaderTable/TeamLeaderTable";
import { teamLeaderMenu } from "../TitleList";


const TeamLeader = () => {
  const userdata = JSON.parse(localStorage.getItem("user"));
  const [formData, setFormData] = useState({
    firmId: "",
    teamLeaderNm: "",
    dt: "",
    userId: userdata?.ID,
  });

  const dispatch = useDispatch();
  const firmlist = useSelector(selectFirm);
  useEffect(() => {
    dispatch(fetchCompanyData());
  }, [dispatch]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value.toUpperCase(),
    });
  };

  const handleDateChange = (e) => {
    setFormData({
      ...formData,
      dt: e.target.value,
    });
  };

  const [errors, setErrors] = useState({});
  const handleSubmit = async (event) => {
    event.preventDefault();
    // Validate department name
    if (!formData.teamLeaderNm.trim()) {
      setErrors({ teamLeaderNm: "Team Leader Name is required" });
      return;
    }
    if (!formData.dt) {
      setErrors({ dt: "Date is required" });
      return;
    }

    // if (!formData.firmId.trim()) {
    //     setErrors({ firmId: 'firm Name is required' });
    //     return;
    // }

    try {
      const result = await dispatch(insertTeamLeader(formData)).unwrap();
      console.log("POST request successful!", result);
      if (result?.status === "failed") {
        alert(result?.msg[0]);
      } else {
        alert(result?.msg);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error while making POST request:", error);
    }
  };

  const isDesktop = useMediaQuery("(min-width:768px)"); // Adjust the breakpoint as per your requirement

  const dropdownFirm = [
    {
      label: "Firm",
      id: "firmId",
      options: firmlist?.data || [],
      value: formData.firmId,
      onChange: (newValue) =>
        handleDropdownChange(
          { target: { name: "firmId", value: newValue ? newValue.ID : "" } },
          "firmId"
        ),
      getOptionLabel: (option) => option.firmNm || "",
      isOptionEqualToValue: (option, value) => option.ID === value.ID,
      valueFinder: (options, value) => {
        if (Array.isArray(options)) {
          return options.find((item) => item.ID === value) || null;
        }
        return null;
      },
      errors: errors.firmId,
    },
  ];

  const handleDropdownChange = (e, dropdownType) => {
    const { value } = e.target;

    setFormData({
      ...formData,
      [dropdownType]: value,
    });
  };

  return (
    <>
      <Titlebar data={teamLeaderMenu} />
      <div style={{ margin: "1% 0.5%" }}>
        <h2>Team Leader Entry</h2>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper style={{ padding: "3vh", margin: "0" }}>
              <Grid container spacing={0.5}>
                {/* {dropdownFirm?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        errors={drop.errors}
                                    />
                                ))
                                } */}

                <Grid item xs={12} md={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid
                      item
                      style={isDesktop ? { width: "30%" } : { width: "100%" }}
                    >
                      <InputLabel htmlFor="dt">Date:</InputLabel>
                    </Grid>
                    <Grid item xs>
                      <FormControl fullWidth error={!!errors.dt}>
                        <TextField
                          id="dt"
                          name="dt"
                          type="date"
                          value={formData.dt}
                          onChange={handleDateChange}
                          inputProps={{ style: styled.inputDate }} // ✅ SAME CSS
                          sx={inputStyles} // ✅ SAME CSS
                        />
                        {errors.dt && (
                          <FormHelperText style={errorStyles}>
                            {errors.dt}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Grid container alignItems="center" spacing={1}>
                    <Grid
                      item
                      style={isDesktop ? { width: "30%" } : { width: "100%" }}
                    >
                      <InputLabel htmlFor="teamLeaderName">
                        Team Leader Name:
                      </InputLabel>
                    </Grid>
                    <Grid item xs>
                      <FormControl fullWidth error={!!errors.teamLeaderNm}>
                        <TextField
                          id="teamLeaderNm"
                          name="teamLeaderNm"
                          value={formData.teamLeaderNm}
                          onChange={handleInputChange}
                          inputProps={{ style: styled.input }}
                          sx={inputStyles}
                        />
                        {errors.teamLeaderNm && (
                          <FormHelperText style={errorStyles}>
                            {errors.teamLeaderNm}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
              <ToastContainer />
            </Paper>
          </Grid>
        </Grid>
        <TeamLeaderTable />
      </div>
    </>
  );
};

export default TeamLeader;
